module.exports = __webpack_public_path__ + "img/base_map.291f71d2.svg";